import React from 'react'

import { Avatar } from '@wartek-id/avatar'
import { Spinner } from '@wartek-id/spinner'

import { GURU_AI_AVATAR_IMAGE_PATH } from 'app/ConversationPage/constants'

interface IConversationMessageProps {}
const ConversationMessageLoading: React.FC<IConversationMessageProps> = () => {
  return (
    <section className="bot">
      <div data-testid="conversation-message-loading" className="p-4 bg-white">
        <div className="flex items-start space-x-4">
          <div className="flex-none">
            <Avatar
              src={GURU_AI_AVATAR_IMAGE_PATH}
              name="Asisten Guru"
              size="md"
              alt="Bot avatar"
            />
          </div>
          <div>
            <div className="!pt-2">
              <Spinner size="sm" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ConversationMessageLoading
